var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"data-name":"Path 3","d":"M1706.82,19l4.124,3.968L1715.068,19","transform":"translate(-1706.474 -18.64)","fill":"none","stroke":"#fff","strokeWidth":"1"}));
}

Chevron.defaultProps = {"viewBox":"0 0 8.942 5.023"};

module.exports = Chevron;

Chevron.default = Chevron;
